module.exports = __webpack_public_path__ + "static/media/android.573b5766.svg";